import { render } from "./UniversalTooltip.vue?vue&type=template&id=537c4252"
import script from "./UniversalTooltip.vue?vue&type=script&lang=js"
export * from "./UniversalTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__